'use client'

import { searchEvents } from '@/actions/event'
import { useEffect, useState } from 'react'
import EventCardFuture from './event-card-future'
import EventCardPrevious from './event-card-previous'
import GamesSection from './games'

const DriverActivity = ({ user, sortedPast, sortedFuture, games }) => {
  let nextEvent = null
  let lastEvents = null

  if (sortedPast?.length >= 2) {
    lastEvents = sortedPast.slice(-2)
  } else if (sortedPast.length >= 1) {
    lastEvents = sortedPast.slice(-1)
  }

  if (sortedFuture?.length >= 1) {
    nextEvent = sortedFuture.slice(0, 1)[0]
  }

  return (
    <div className="flex flex-col">
      <div className="font-inter text-[32px]">Driver Activity</div>
      <div className="mt-3 w-full rounded-md border border-neutral-blue-700 bg-neutral-blue-800 p-4">
        <EventCardFuture nextEvent={nextEvent} games={games} user={user} />

        {nextEvent ? <div className="divider"></div> : null}
        <div className="flex flex-col gap-6">
          {lastEvents?.length > 0 ? (
            lastEvents.map((previousEvent, index) => (
              <EventCardPrevious
                key={index}
                previousEvent={previousEvent}
                games={games}
                user={user}
              />
            ))
          ) : (
            <div className="flex min-h-[100px] flex-col items-center justify-center">
              <p className="text-xl">
                This user hasn't participated in any events yet!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default function ViewDriver({ user, userStats, session, games }) {
  const [events, setEvents] = useState([])

  useEffect(() => {
    async function fetchEvents() {
      const events = await searchEvents({
        where: {
          championship: {
            reviewedTs: {
              not: null,
            },
            community: {
              deleteTs: null,
              isPrivate: false,
            },
          },
          attendees: {
            some: {
              userId: user.id,
            },
          },
          isPublished: true,
        },

        include: {
          sessions: {
            orderBy: {
              targetDateTime: 'asc',
            },
          },
          championship: {
            include: {
              community: true,
            },
          },
        },
      })
      setEvents(events)
    }
    fetchEvents()
  }, [user.id])

  if (!user?.driverGames || user.driverGames.length === 0) {
    return (
      <div className="flex flex-col gap-4">
        <div className="rounded-md bg-neutral-blue-800 px-4 py-10 text-center">
          <h4 className="text-h-4 font-semibold">No Driver Profile</h4>
          <p className="mt-2">
            This user does not have a driver profile yet. Information and
            activities related to driving will appear here once a profile is
            completed.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-4">
      <GamesSection games={userStats.games} user={user} />

      {events && (
        <DriverActivity
          user={user}
          sortedFuture={events.filter((event) => !event.isPast)}
          sortedPast={events.filter((event) => event.isPast)}
          games={games}
        />
      )}
    </div>
  )
}
